import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './FamilyGrid.css'
// import {Row, Col} from 'react-flexbox-grid'
import format from '../../helpers/format'
import analytics from '../../helpers/analytics'
import config from '../../config'
import { Link, LinkIcon } from '../../components'
// import convert from '../../helpers/convert'

@CSSModules(Styles)
export default class FamilyGrid extends Component {
  static propTypes = {
    fullGrid: PropTypes.bool,
    topN: PropTypes.number,
  }

  constructor(props){
    super(props)
  }
  onMouseEnter = (prop) => {
    return () => {
      // this.state.onHovers[prop] = true
      const onHovers = Object.assign({},this.state.onHovers)
      onHovers[prop] = true
      this.setState({onHovers: onHovers})
      // console.log('enter:',onHovers )
    }
  }

  onMouseLeave = (prop) => {
    return () => {
      const onHovers = Object.assign({},this.state.onHovers)
      delete onHovers[prop]
      this.setState({onHovers: onHovers})
      // console.log('leave:',onHovers )
      // console.log('leave:',this.state.onHovers )
    }
  }

  renderCompanies = () => {
    return config.familyFunds.slice(0, (this.props.topN || config.familyFunds.length)).map((c,idx) =>{
      return this.renderCompany(
        idx,
        c.fund_family_name,
        c.ff_all_asset_sum,
        c.ff_all_weight_total,
        c.num_equity_funds,
        4
      )
    })
  }

  renderLogo = (title) => {
    const fileName = format.imgPath(title)
    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/fam/'+fileName+'.png')
      hasLogo = true
    }
    catch (e) {
      // console.log('')
    }
    if (hasLogo) {
      return (
        <img
          styleName='box-title-logo'
          src={companyLogo}
          alt={title}
        />
      )
    } else {
      // console.log(fileName)
      return (
        <span>{title}</span>
      )
    }
  }

  renderCompany = (idx, title, asset, perc, numFunds, rating) => {
    const safeName = encodeURIComponent(title)
    return(
      <div key={idx} styleName='companies-box-wrap'>
        <Link
          onMouseEnter={this.onMouseEnter('company-'+idx)}
          onMouseLeave={this.onMouseLeave('company-'+idx)}
          log={analytics.eventToFamily(title)}
          to={config.routes.families+'?q='+safeName}
          styleName='companies-link'
          title={title}
        >
          <div styleName={'companies-box-'+rating}>
            <div styleName='box-title-wrapper'>
              { this.renderLogo(title) }
            </div>
            <div styleName='box-subtitle'>
              {numFunds} equity funds analyzed
            </div>
            <div styleName='box-subtitle'>
              <strong>{format.perc(perc, true)}</strong> fossil fuel exposure
            </div>
            <div styleName='box-subtitle'>
              <strong>{format.money(asset, true, 'US Dollar', false, 0)}</strong>
              &nbsp;
              in fossil fuel stocks
            </div>
            <div styleName='learn-more-wrap'>
              <div styleName={'learn-more-'+rating}>
                More<LinkIcon />
              </div>
            </div>
          </div>
        </Link>
      </div>
    )
  }

  renderAddtl = () => {
    if (!this.props.fullGrid) {
      return null
    }

    const allFams = config.formOptions.fundFamilyAll
    const filteredFams = allFams.reduce((arr, el) => {
      if (el.name !== 'All funds') {
        arr.push(el)
      }
      return arr
    }, [])

    return (
      <div>
        <div styleName='addtl-fam-info'>
          <strong>
            We analyze funds from over one hundred asset managers.
            &nbsp;
            See the full list below:
          </strong>
        </div>
        <div styleName='addtl-fam-links'>
          { filteredFams.map( (el, ix) => {
            return (
              <Link
                to={config.routes.families+'?q='+el.name}
                title={el.name}
                key={el.name}
                strong={true}
              >
                <div styleName='addtl-fam-link'>

                  <div styleName='addtl-fam-link-logo'>
                    { this.renderLogo(el.name, el.name) }
                  </div>

                  <div styleName='addtl-fam-link-lbl'>
                    { el.name }<LinkIcon />
                  </div>

                </div>
              </Link>
            )
          }) }
        </div>
      </div>
    )
  }

  render() {
    return (
      <div styleName='companies'>
        <div styleName='companies-anchor' id='companies'/>
        <div styleName='companies-inner'>
          <div styleName='companies-title'>
            Fund managers have trillions of dollars invested in the stocks of
            fossil fuel companies
          </div>
          <div styleName='companies-info'>
            <strong>
              Major asset managers handle the retirement savings of millions
              of Americans.
            </strong>
            &#160;
            Their mission is to help people save for the future - but they're
            directing trillions of dollars of capital to the carbon polluters
            maintaining and expanding the fossil fuel infrastructure that
            threatens our future.
          </div>
          <div styleName='companies-info'>
            <strong>
              Are your savings invested with one of these financial giants?
            </strong>
            &#160;
            Find out just how much they have invested in the top owners of
            carbon reserves, the largest coal-fired utilities, and other
            fossil fuel companies. Then, share to spread the word: business as
            usual is killing the climate.
          </div>
          <div styleName='companies-boxes'>
            { this.renderCompanies() }
          </div>
          { this.renderAddtl() }
        </div>
      </div>
    )
  }
}
